module.exports = __webpack_public_path__ + "static/media/exclamation-error.378ee595.svg";